export enum LicenseKeyType {
  DocumentControl = 1,
  Workflow = 2,
  WorkflowRegAgent = 3,
  WorkflowSyncAgent = 4,
  ADAgent = 5,
  PDFGenerator = 6,
  DocumentImport = 7,
  Scheduler = 8,
  Training = 9,
  Branding = 10,
  Exams = 11,
  ExternalUsers = 12,
  LicenseType = 13,
  Api = 14,
  Idp = 15,
  EntitiesNumber = 16,
  AnonymousPortal = 17,
  MailMonitoring = 18,
  AICopilot = 19,
  AIButton = 20,
  AIExams = 21,
  AIMailMonitoring = 22,
  Qualifications = 23,
  Checklists = 24
}